<div class="language-selector_flag">
    <svg class="language-selector_flag_icon">
        <use [attr.xlink:href]="'#flags--' + currentLang?.flagKey"></use>
    </svg>
</div>

<span>{{currentLang?.shortLabel | l10n}}</span>

<svg class="language-selector_toggle-menu-icon">
    <use xlink:href="#chevron-down"></use>
</svg>
